import { useEffect,useState } from 'react'
import { useParams } from 'react-router-dom'
import { post } from '../../../utils/axios'
import { Alert, Card, CardContent, Grid, TextField, Typography } from '@mui/material'
import { updateSawTicketsData } from '../../../utils'

import './Tickets.css'
import Button from '../../../components/Button'
import { toast } from 'react-toastify'

const View = () => {

    const { id } = useParams()

    const [fetchedData,setFetchedData] = useState(false)
    const [ticket,setTicket] = useState({})
    const [message,setMessage] = useState('')
    const [isLoading,setIsLoading] = useState(false)

    const getData = () => {
        post('Support/GetRequest',{offset: 0,limit: 1000,id}).then(({ data }) => {
            if(data.isSuccess){
                const thisTicket = data.data.find(t => t.id == id)
                if(thisTicket){
                    setTicket(thisTicket)
                    updateSawTicketsData(id,thisTicket.supportTickets.filter(message => [83,103].includes(message.issuerRole)).length)
                }
            }
        }).finally(() => {
            setFetchedData(true)
        })
    }

    useEffect(() => {
        getData()
    },[])

    const addAnswer = () => {
        setIsLoading(true)
        const postedData = {
            id,
            ticketMessage: message
        }
        post('Support/AddRequest',postedData).then(({data}) => {
            if(data.isSuccess){
                toast.success('پاسخ جدید با موفقیت ثبت شد')
                getData()
                setMessage('')
            }else
                toast.error(data.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">مشاهده درخواست {ticket.requestNo}</h3>
            <div className="safe-area">
                {Object.keys(ticket).length ? <>
                    <Card sx={{width: '100%',mb: ticket.status != 3 ? 2 : 6}}>
                        <CardContent sx={{pt: 3}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {ticket.supportTickets.map(message => <div className={`message-row ${[83,103].includes(message.issuerRole) ? 'odd' : 'even'}`}>
                                        <div className="message-item">
                                            <span className="message-item-name">{message.userFullName}</span>
                                            <span className="message-item-date" dir="ltr">{new Date(message.insertDate).toLocaleDateString('fa-IR') + ' ' + new Date(message.insertDate).toLocaleTimeString('fa-IR')}</span>
                                            <p>{message.ticketMessage}</p>
                                        </div>
                                    </div>)}
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    {ticket.status != 3 ? <Card sx={{width: '100%',mb: 6}}>
                        <CardContent sx={{pt: 3}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography sx={{fontWeight: 'bold',fontSize: '15px',mb: 3}}>ارسال پاسخ جدید</Typography>
                                    <TextField label="پاسخ" variant="standard" multiline rows={5} fullWidth sx={{mb: 2.5}} onChange={e => setMessage(e.target.value)} value={message} />
                                    <Button type="submit" isLoading={isLoading} fullWidth={true} sx={{mt: 2,py: 1.5}} className="custom-btn-primary" variant="contained" disabled={!message} onClick={addAnswer}>ارسال پاسخ</Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card> : ''}
                </> : (fetchedData ? <Alert variant="standard" color="info">درخواست مورد نظر یافت نشد</Alert> : <p style={{fontSize: 13,textAlign: 'center'}}>در حال بارگذاری</p>)}
            </div>
        </Grid>
    )
}

export default View